import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BotaoDuplo from '../../Componentes/BotaoDuplo';
import CorpoPagina from '../../Componentes/CorpoPagina';
import SubTopicoTexto from '../../Componentes/SubTopicoTexto';
import TextInput, { FixedInput } from '../../Componentes/TextInput';
import TopicoTexto from '../../Componentes/TopicoTexto';
import { StoreContexto } from '../../Contexto/Provider';
import '../../Estilos/QuebraPagina.css';
import setDados, { getDados } from '../../Funções/Conexão';
import Init from '../../Funções/Init';
export default function DadosCadastrais() {
  const { token, setToken } = useContext(StoreContexto);
  const { idLogin, setIdLogin } = useContext(StoreContexto);
  const { senhaSalva, setSenhaSalva, controleSalvo } = useContext(StoreContexto);
  const [load, setLoad] = useState(true);

  const [perfis, setPerfis] = useState([]);
  const [updatePage, setUpdatePage] = useState(false);

  const [nomeCadastro, setNomeCadastro] = useState('');
  const [senhaCadastro, setSenhaCadastro] = useState('');
  const [controleCadastro, setControleCadastro] = useState('');
  const [matrículaCadastro, setMatrículaCadastro] = useState('');
  const [emailCadastro, setEmailCadastro] = useState('');
  const [perfilCadastro, setPerfilCadastro] = useState('');
  const [habilitadoCadastro, setHabilitadoCadastro] = useState('N');

  const [novaSenha1, setNovaSenha1] = useState('');
  const [novaSenha2, setNovaSenha2] = useState('');
  const [senhaAtual, setSenhaAtual] = useState('');

  const [pageUpdated, setPageUpdated] = useState(false);

  const navega = useNavigate();
  const location = useLocation();

  const getID = async () => {
    console.log('PegaID');

    getDados(Init.url + 'getUserById', { controle: controleSalvo, senha: senhaSalva, id: idLogin })
      .then((js) => {
        js.info.map((item) => {
          console.log('Entrou');
          setNomeCadastro(item.nome);
          setControleCadastro(item.controle);
          setMatrículaCadastro(item.matricula);
          setEmailCadastro(item.email);
          setPerfilCadastro(item.perfil);
          setPageUpdated(true);
          setLoad(false);
        });
      })
      .catch((erro) => {
        console.log('Erro BAnco');
      });
  };

  useEffect(() => {
    if (!pageUpdated) {
      getID();
    }
  });

  return (
    <CorpoPagina loading={load}>
      <div
        style={{ backgroundColor: '#F9FBFF', width: '90%', height: '100vh', overflowY: 'scroll' }}
      >
        <div className="ContainerGeral">
          <TopicoTexto titulo="Dados Cadastrais" />

          <div className="MeioLinha">
            <div
              style={{
                backgroundColor: 'white',
                maxWidth: 540,
                minWidth: 380,
                width: '28vw',
                height: 505,
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <SubTopicoTexto titulo="DADOS PESSOAIS" />
                <TextInput
                  titulo="Nome"
                  padrao={nomeCadastro}
                  placeholder="Insira o nome"
                  tipo="text"
                  largura="90%"
                  onUpdate={(txt) => setNomeCadastro(txt)}
                />
                <TextInput
                  titulo="E-mail"
                  padrao={emailCadastro}
                  placeholder="Insira o e-mail cadastrado"
                  tipo="e-mail"
                  largura="90%"
                  top={15}
                  onUpdate={(txt) => setEmailCadastro(txt)}
                />

                <div
                  style={{
                    width: '90%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingTop: 15,
                  }}
                >
                  <FixedInput
                    titulo="Controle"
                    padrao={controleCadastro}
                    placeholder="Insira o controle"
                    tipo="text"
                    largura="45%"
                  />
                  <FixedInput
                    titulo="Matrícula"
                    padrao={matrículaCadastro}
                    placeholder="Insira matrícula"
                    tipo="text"
                    largura="45%"
                    onUpdate={(txt) => setMatrículaCadastro(txt)}
                  />
                </div>
              </div>
            </div>

            <div style={{ marginLeft: 32 }}></div>

            <div
              style={{
                backgroundColor: 'white',
                maxWidth: 540,
                minWidth: 380,
                width: '28vw',
                height: 505,
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <SubTopicoTexto titulo="DADOS DE ACESSO" />
                <TextInput
                  titulo="Senha"
                  password
                  placeholder="Insira a senha atual"
                  tipo="password"
                  largura="90%"
                  onUpdate={(txt) => {
                    setSenhaAtual(txt);
                  }}
                />
                <TextInput
                  titulo="Nova senha"
                  password
                  placeholder="Insira uma nova senha"
                  tipo="password"
                  largura="90%"
                  top={15}
                  onUpdate={(txt) => {
                    setNovaSenha1(txt);
                  }}
                />
                <TextInput
                  titulo="Confirmar nova senha"
                  password
                  placeholder="Confirme a nova senha"
                  tipo="password"
                  largura="90%"
                  top={15}
                  onUpdate={(txt) => {
                    setNovaSenha2(txt);
                  }}
                />
              </div>
            </div>
          </div>

          <BotaoDuplo
            nome="Salvar"
            nomeVolta="Cancelar"
            top={16}
            bottom={32}
            clicado={async () => {
              let senha = senhaAtual;
              if (novaSenha1 == novaSenha2 && senhaAtual == senhaSalva) {
                if (novaSenha1 != '') {
                  setSenhaAtual(novaSenha1);
                  senha = novaSenha1;
                }

                setDados(Init.url + 'RegisterUser', {
                  controle: controleSalvo,
                  senha: senhaSalva,
                  id: idLogin,
                  matriculaUser: matrículaCadastro,
                  email: emailCadastro,
                  nomeUser: nomeCadastro,
                  perfilUser: perfilCadastro,
                  controleUser: controleCadastro,
                  senhaUser: senha,
                  habilitado: habilitadoCadastro,
                })
                  .then(() => {
                    navega(-1);

                    setSenhaSalva(senha);
                  })
                  .catch((erro) => {
                    alert('Erro de Conexão');
                  });
              }
            }}
          />
        </div>
      </div>
    </CorpoPagina>
  );
}
